<igx-time-picker
#timePicker
[(ngModel)]="date"
[mode]="mode"
[format]="format">
</igx-time-picker>

